import React from "react";
import StaticContentPage from "./StaticContentPage";
import { paymentPolicyText } from "../data/staticPagesContent";

const PaymentPolicy = () => {
  return (
    <StaticContentPage
      title="Payment Policy"
      seoTitle="Payment Policy | Secure Payments | Eveness"
      seoDescription="Learn about Eveness payment methods, secure checkout, billing information, and payment processing policies."
      canonicalPath="/policies/payment-policy"
    >
      {paymentPolicyText}
    </StaticContentPage>
  );
};

export default PaymentPolicy;